import { render, staticRenderFns } from "./feedbackList.vue?vue&type=template&id=141b44a5&"
import script from "./feedbackList.vue?vue&type=script&lang=js&"
export * from "./feedbackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports